export default class Provider {
  providerID = null;

  providerName = null;

  providerDefaultLookupType = null;

  providerKey = null; // This is customer specific

  providerKeyID = null;

  providerTypes = [];

  constructor(providerID, providerName, providerDefaultLookupType) {
    this.providerID = providerID;
    this.providerName = providerName;
    this.providerDefaultLookupType = providerDefaultLookupType;
  }
}
